import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TaskComment } from '@app/interfaces/lm/kanban-board';
import { Auth } from '@app/interfaces/sys/auth';
import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { KanbanBoardService } from '@services/lm/kanban-board.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SelectOption } from '@app/interfaces/sys/dict';
import { Account } from '@app/interfaces/sys/account';
import { AccountService } from '@services/sys/account.service';
import { InputContentComponent } from '@app/task-shared/components/task-detail/components/input-content/input-content.component';
import { co } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'app-activity-comment',
    templateUrl: './activity-comment.component.html',
    styleUrl: './activity-comment.component.less',
})
export class ActivityCommentComponent implements OnChanges {
    @Input() item: TaskComment = {} as TaskComment;
    @Input() projectMembers: SelectOption[] = [];
    @Input() taskId!: string;
    @Input() userInfo: Auth = {} as Auth;
    @Input() isAdd = false;
    @Input() isSubtask = false;
    @Input() accountList: Account[] = [];
    @Input() inactiveUsers: boolean = false;
    @Output() saveComment = new EventEmitter();
    @Output() deleteComment = new EventEmitter();

    @ViewChild('inputContentCom') inputContentCom!: InputContentComponent;

    isEdit = false;
    saveLoading = false;
    displayValue: SafeHtml = '';

    constructor(private kanbanBoardService: KanbanBoardService,
        private modal: NzModalService,
        private message: NzMessageService,
        private sanitizer: DomSanitizer,
        private accountService: AccountService,
        private confirmationService: ConfirmationService
    ) {
    }

    async ngOnInit(): Promise<void> {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { item } = changes;
        if (item) {
            this.displayValue = this.getSafeHtml(this.item.value);
        }
    }

    get isSelfCommit(): boolean {
        return this.item.createdById === this.userInfo.id?.toString();
    }

    handleEdit(): void {
        this.isEdit = true;
        setTimeout(() => {
            this.inputContentCom.handleEdit(this.item.value);
        });
    }

    async handleSave(data: {
        value: string,
        newFiles: string[]
    }): Promise<void> {
        try {
            this.saveLoading = true;
            const commentId = this.item?.id;
            const { value, newFiles } = data;
            let commentData: TaskComment = {} as TaskComment;
            this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                if (commentId) {
                    commentData = await this.kanbanBoardService.editComment({
                        id: commentId,
                        isSubtask: this.isSubtask,
                        value
                    });
                } else {
                    commentData = await this.kanbanBoardService.addComment({
                        taskId: this.taskId,
                        isSubtask: this.isSubtask,
                        value
                    });
                }
                this.saveComment.emit({
                    commentInfo: commentData,
                    newFiles
                });
            }, () => { this.handleCancel(); });
        } finally {
            this.isEdit = false;
            this.saveLoading = false;
        }
    }

    handleRemove(): void {
        this.modal.confirm({
            nzTitle: 'The comment will be deleted.',
            nzOkText: 'Yes',
            nzCancelText: 'No',
            nzOkType: 'primary',
            nzOkDanger: true,
            nzStyle: { top: '40vh' },
            nzOnOk: () => {
                try {
                    this.confirmationService.confirmUpdateTask(this.inactiveUsers, async () => {
                        this.item.deleteLoading = true;
                        await this.kanbanBoardService.removeComment(this.item.id, this.isSubtask);
                        this.message.success('Deleted successfully');
                        this.deleteComment.emit();
                    }, () => { this.handleCancel(); });
                } finally {
                    this.item.deleteLoading = false;
                }
            },
        });
    }

    handleCancel(): void {
        this.isEdit = false;
    }

    getSafeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    getUserInfo(userId: string): Account {
        const account = this.accountService.formatUserInfo(this.accountList, userId);
        return account;
    }

}
